import { useCallback, useMemo } from 'react';

import { useTranslateFromNearestProvider } from '~/shared/context/use-translate';
import type { SectionTagDefinition, SectionTitleIdentifier } from '~/shared/data-contract/job-profile';
import { buildSectionNameMap, resolveSectionTitle } from '~/shared/data-contract/section-tag-utils';
import type { TranslationKey } from '~/shared/internationalization/translation';

import { useActiveLanguage } from '../providers/ActiveLanguageProvider';

export const useTranslatedSectionTitle = (sectionTags: readonly SectionTagDefinition[] | undefined) => {
    const sectionNameMap = useMemo(() => buildSectionNameMap(sectionTags), [sectionTags]);
    const { activeLanguage } = useActiveLanguage();
    const translate = useTranslateFromNearestProvider();

    return useCallback(
        (structuredItem: SectionTitleIdentifier) => {
            const fromSectionTags = resolveSectionTitle(sectionNameMap, structuredItem.id, activeLanguage);

            if (fromSectionTags !== null) return fromSectionTags;

            const i18nKey: TranslationKey = `attributes.job-profile-tags.${structuredItem.tag}`;
            const fromI18n = translate(i18nKey);
            if (fromI18n !== i18nKey) return fromI18n;

            return structuredItem.tag;
        },
        [sectionNameMap, activeLanguage, translate],
    );
};
